import { createFileRoute } from '@tanstack/react-router'

import { SipPage } from '#/modules/communication/sip-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/sip')({
  component: SipPage,
  validateSearch: validateListSearch,
})
